<template>
  <div>
    <notifications />
    <ErrorBoundary>
      <router-view />
    </ErrorBoundary>
  </div>
</template>

<script>
import ErrorBoundary from '@/components/main/ErrorBoundary';

export default {
  name: 'App',

  components: {
    ErrorBoundary
  },

  data: () => ({
    //
  })
};
</script>

<style lang="scss">
.vue-notification {
  padding: 10px;
  margin: 0 5px 5px;
  font-size: 1.6vh;
}
.v-dialog--fullscreen {
  background-color: white;
}
input {
  &[type='number'] {
    -moz-appearance: textfield;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }
}
</style>
